import create from 'zustand';
import produce from 'immer';
import Transform from 'utils/securities/transformData';
import { getOrderDetail } from '../api/order';
import { OrderItem } from '../types/api/orderList';

type DataTypes = Partial<OrderItem>;

interface State {
  data: DataTypes;
  isLoading: boolean;
}

interface Action {
  loadOrderDetail: (orderId: string) => Promise<DataTypes>;
  resetOrderDetail: () => void;
  updateOrderDetail: (newData: DataTypes) => void;
}

const initialState: State = {
  data: undefined,
  isLoading: false,
};

const useOrderDetailStore = create<State & Action>((set, get) => ({
  ...initialState,
  loadOrderDetail: async (orderId) => {
    try {
      set({ isLoading: true });

      const axiosResponse = await getOrderDetail(orderId);
      const { data: responseData } = axiosResponse.data;
      const data = Transform.orderDetail(responseData);

      set({ data, isLoading: false });
      return data;
    } catch (error) {
      set({ isLoading: false });
      return Promise.reject(error);
    }
  },
  resetOrderDetail: () => {
    set(initialState);
  },
  updateOrderDetail: (newData) => {
    if (typeof newData !== 'object') return;

    const currentOrderId = get().data?.orderid;

    if (currentOrderId !== newData.orderid) return;

    set(
      produce((state) => {
        state.data = newData;
      }),
    );
  },
}));

export default useOrderDetailStore;
